import { Icon } from "@components/Icon";
import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import ReactPaginate, { type ReactPaginateProps } from "react-paginate";
import tw, { styled } from "twin.macro";

type PaginationProps = ReactPaginateProps & {
  loading?: boolean;
};

const Container = styled(StyledContainer)`
  ${tw`flex flex-col items-end relative`}

  .pagination-item {
    ${tw`flex items-center justify-center bg-transparent border w-maxi h-maxi mx-pico border-grey text-primary text-body focus-visible:outline-1 focus-visible:outline-grey focus-visible:outline-offset-1 focus-visible:outline-dashed`}
  }

  .pagination-item:hover {
    ${tw`border-none bg-tertiary`}
  }

  .pagination-item.selected {
    ${tw`border-none bg-primary text-white`}
  }

  .pagination-item > [role="button"] {
    ${tw`px-mini py-micro`}
  }

  .pagination-nav {
    ${tw`flex items-center justify-center w-maxi h-maxi`}
  }

  .pagination-nav > [aria-disabled="true"] {
    ${tw`cursor-default text-grey`}
  }

  .pagination-break {
    ${tw`flex items-center justify-center w-maxi h-maxi mx-pico`}
  }
`;
const Wrapper = styled(ReactPaginate)`
  ${tw`flex`}
`;
const NextIcon = tw(Icon)`
`;
const PreviousIcon = tw(Icon)`
  transform rotate-180
`;
const ShowEmpty = tw.p`
  absolute -bottom-3 right-4 italic
`;

const Pagination = ({
  pageCount,
  pageRangeDisplayed,
  marginPagesDisplayed,
  onPageChange,
  loading,
}: PaginationProps) => {
  return (
    <Container width="full">
      <Wrapper
        breakClassName="pagination-break"
        breakLabel="..."
        nextClassName="pagination-nav"
        nextLabel={<NextIcon name="chevron" size="xxs" />}
        previousClassName="pagination-nav"
        previousLabel={<PreviousIcon name="chevron" size="xxs" />}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={pageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        renderOnZeroPageCount={null}
        pageClassName="pagination-item"
        onPageChange={onPageChange}
      />
      {loading && <ShowEmpty>Loading...</ShowEmpty>}
    </Container>
  );
};

export default Pagination;
